var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.496,
    height: 24,
    viewBox: "0 0 25.496 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_Icon",
    "data-name": "Search Icon",
    transform: "translate(0.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    d: "M24,24H0V0H24Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_1-DSLR_Camera",
    transform: "translate(-0.748 -33.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79906",
    "data-name": "Path 79906",
    d: "M23.638,36.85H16.889l-1.363-2.289a.739.739,0,0,0-.635-.361H10.6a.739.739,0,0,0-.635.361L8.607,36.85H6.392v-.5a.739.739,0,0,0-.739-.739H2.919a.739.739,0,0,0-.739.739v.5H1.858A1.858,1.858,0,0,0,0,38.709V52.163a1.858,1.858,0,0,0,1.858,1.858h21.78A1.858,1.858,0,0,0,25.5,52.163V38.709A1.858,1.858,0,0,0,23.638,36.85ZM12.748,50.725a5.289,5.289,0,1,1,5.289-5.289A5.289,5.289,0,0,1,12.748,50.725Zm9.73-10.044H20.163a.739.739,0,0,1,0-1.478h2.316a.739.739,0,1,1,0,1.478Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 3.695,
    cy: 3.695,
    r: 3.695,
    transform: "translate(9.053 41.741)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/camera_white.c0548902fb3fd84586c15044f4fc0bbd.svg";
export { ForwardRef as ReactComponent };